import { Stack } from "@certa/catalyst/layouts/Stack";
import {
  TypographyColors,
  TypographyVariants,
  Typography
} from "@certa/catalyst/components/Typography";
import type { BreadcrumbSeparatorProps } from "../Breadcrumb.types";
import { SEPARATOR_CHARACTER_SLASH } from "../Breadcrumb.constants";

const BreadcrumbSeparator = ({
  separator = SEPARATOR_CHARACTER_SLASH
}: BreadcrumbSeparatorProps) => {
  return (
    <li>
      <Stack padding="4 0">
        <Typography
          color={TypographyColors.NEUTRAL_500}
          variant={TypographyVariants.LABEL_SM}
        >
          {separator}
        </Typography>
      </Stack>
    </li>
  );
};

export { BreadcrumbSeparator };
